import React,{useEffect,useState,useRef} from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import SearchList from "../../components/ProductList/SearchList";
import Footer from "../../components/Footer";
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import queryString from "query-string";

import './ProductList.styles.css';

const ProductList = () => {
	
	const [url, setUrl] = useState(false);
	const [baseUrl, setBaseUrl] = useState(false);
	const queryParams = queryString.parse(window.location.search, {decode:false})
	const productBasename = useRef('All Products');

	useEffect(() => {
		setUrl(false)
	}, [])

	useEffect(() => {
		if(queryParams.keyword){
			productBasename.current=`Search Result for '${queryParams.keyword}'`;
		}
		setBaseUrl(`/product/search?keyword=${queryParams.keyword}`);
		setUrl(`/product/search?keyword=${queryParams.keyword}&limit=12&offset=0`);
	}, [queryParams])

	return (
		<div>
			{
				url &&
				<>
					<Helmet>
					<title>Search List</title>
					</Helmet>
					<Header />
            		<ActiveCatalogue/> 
					<SearchList baseUrl={baseUrl} url={url} productBasename={productBasename.current}/>
					<Footer />	
				</>
			}
			
		</div>
	);
};

export default ProductList;